import React, { useEffect, useRef, useState } from 'react'
import styled from '@emotion/styled'
import { FusionContentZIndex } from '../../../theme/FusionStyle'

export interface MarkerProps {
	cx: number
	cy: number
	rotateDeg?: number
	active: boolean
	onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void,
	width?: number,
	height?: number,
	top?: number,
	label?: string,
}

const L1HumanoidMarkerRoot = styled.button<MarkerProps>(({theme, cx, cy, rotateDeg, active, top, width, height}) => {
	return {
		boxSizing: 'border-box',
		all: 'unset',
		'&:hover': {
			cursor: 'pointer',
		},
		position: 'absolute',
		zIndex: FusionContentZIndex.Content + 1,
		width,
		height,
		left: cx - ((width ?? 0) / 2),
		top,
		'svg': {
			transform: rotateDeg ? `rotate(${rotateDeg}deg)` : 'none',
		},
		'svg circle': {
			fill: theme.colors.blueMain,
			opacity: .16,
		},
		'svg rect':{ 
			fill: theme.colors.stopRed,
			opacity: active ? 1 : .16,
		}
	}
})

export const L1HumanoidMarker = (props: MarkerProps) => {
	const height = 40
	const width = 40

	return (
		<L1HumanoidMarkerRoot {...props} height={height} width={width} top={props.cy - (height / 2)}>
			<svg viewBox="0 0 48 48" width="100%" xmlns="http://www.w3.org/2000/svg">
				<circle cx="24" cy="24" r="24" />
				{props.label && <text fontSize="20" fill="white">{props.label}</text>}
				<rect x="0" y="20" width="48" height="8" />
			</svg>
		</L1HumanoidMarkerRoot>
	)
}

// This component uses auto text rotation magic to ensure a label fits correctly
// within its assigned rectangle
export const L1ResizableHumanoidMarker = (props: MarkerProps) => {
	const height = props.height ?? 40
	const width = props.width ?? 40

	const textRef = useRef<SVGTextElement>(null);
	const [rotate, setRotate] = useState(false);

	useEffect(() => {
	if (textRef.current) {
		const textBox = textRef.current.getBBox();

		if (textBox.width > width) {
			setRotate(true);
		}
	}
	}, [props.label, width]);

	return (
		<L1HumanoidMarkerRoot {...props} height={height} width={width} top={props.cy}>
			<svg width={width} height={height} xmlns="http://www.w3.org/2000/svg">
				<rect x="0" width={width} height={height} />
				{
					props.label && (
						<text
							ref={textRef}
							x={width / 2} 
							y={height / 2} 
							fontSize="12"
							fontWeight={600}
							textAnchor="middle"
							dominantBaseline="middle"
							transform={
								rotate
									? `rotate(90, ${width / 2}, ${height / 2})`
									: "none"
							}
							fill={props.active ? "white" : "black"}
						>
							{props.label}
						</text>
					)
				}
			</svg>
		</L1HumanoidMarkerRoot>
	)
}